const KeyCodes = {
  break: 3,
  del: [8, 46],
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  shift: 16,
  ctrl: 17,
  control: 17,
  alt: 18,
  pauseBreak: 19,
  capsLock: 20,
  esc: 27,
  escape: 27,
  conversion: 28,
  nonConversion: 29,
  space: 32,
  spacebar: 32,
  spaceBar: 32,
  pageUp: 33,
  pageup: 33,
  pageDown: 34,
  pagedown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  select: 41,
  print: 42,
  execute: 43,
  prntScr: 44,
  insert: 45,
  0: [48, 96],
  1: [49, 97],
  2: [50, 98],
  3: [51, 99],
  4: [52, 100],
  5: [53, 101],
  6: [54, 102],
  7: [55, 103],
  8: [56, 104],
  9: [57, 105],
  colon: 58,
  equals: [59, 61, 187],
  lt: 60,
  lessThan: 60,
  at: 64,
  atSymbol: 64,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  windows: [91, 92, 93],
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,

  multiply: 106,
  add: 107,
  decimal: 110,
  divide: 111,

  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  f13: 124,
  f14: 125,
  f15: 126,
  f16: 127,
  f17: 128,
  f18: 129,
  f19: 130,
  f20: 131,
  f21: 132,
  f22: 133,
  f23: 134,
  f24: 135,

  numLock: 144,
  scrollLock: 145,

  caret: 160,
  bang: 161,
  exclamation: 161,
  exclamationPoint: 161,
  hash: 163,
  pound: 163,
  dollar: 164,
  dollarSign: 164,
  pageBackward: 166,
  pageForward: 167,
  rightParen: 169,
  rightParenthesis: 169,
  asterisk: 170,
  minusFirefox: 173,
  mute: [173, 181],
  unmute: [173, 181],
  volumeDown: [174, 182],
  volumeUp: [175, 183],
  next: 176,
  previous: 177,
  stop: 178,
  play: 179,
  pause: 179,
  email: 180,

  semicolon: 186,
  comma: 188,
  dash: 189,
  period: [190, 194, 108],

  forwardSlash: [191, 193],
  slash: [191, 193],
  backSlash: 220,
  backslash: 220,
  pipe: 220,

  ash: 192,
  question: 193,
  degree: 193,
  leftBracket: 219,
  rightBracket: 221,
  singleQuote: 222,
  doubleQuote: 222,
  quote: 222,
  backtick: 223,
};

export default KeyCodes;
